<template>
  <div>
    <px-view-header title="Modos de pagamento" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-modos-de-pagamento-list-header :on-click-refresh="onClickRefresh"
                          :on-change-filter="onChangeFilter" />
    <px-modos-de-pagamento-list :modos-de-pagamento="modosDePagamento"
                   :loading="loading"
                   :on-change-options="onChangeOptions"
                   :options-list="optionsList"
                   @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ModosPagamentoService from './modos-pagamento-service';
import ModosDePagamentoList from './ModosDePagamentoList.vue';
import ModosDePagamentoListHeader from './ModosDePagamentoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Modos de pagamento' },
      ],
      modosDePagamento: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: '',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemModosDePagamento', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getModosDePagamento();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getModosDePagamento();
    },
    onClickRefresh() {
      this.getModosDePagamento();
    },
    onRemove(item) {
      this.loading = true;
      ModosPagamentoService.remover(item.id)
        .then(() => {
          this.$toast('Modo de pagamento removido com sucesso', { color: 'success' });
          this.getModosDePagamento();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getModosDePagamento() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ModosPagamentoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.modosDePagamento = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxModosDePagamentoList: ModosDePagamentoList,
    pxModosDePagamentoListHeader: ModosDePagamentoListHeader,
  },
};

</script>
